import React from 'react';
import { Home, Users, UserCheck, Truck, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { userProfiles } from '../mock';
import CTABanner from './CTABanner';

const iconMap = {
  Home,
  Users,
  UserCheck,
  Truck
};

const UserProfiles = () => {
  return (
    <section id="perfiles" className="py-24 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* Building watermark background */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <svg className="absolute left-1/4 bottom-0" width="300" height="400" viewBox="0 0 300 400" xmlns="http://www.w3.org/2000/svg">
          <rect x="50" y="100" width="80" height="300" fill="#082E5C"/>
          <rect x="60" y="120" width="15" height="20" fill="#00D4D8"/>
          <rect x="85" y="120" width="15" height="20" fill="#00D4D8"/>
          <rect x="110" y="120" width="15" height="20" fill="#00D4D8"/>
        </svg>
        <svg className="absolute right-1/4 bottom-0" width="300" height="450" viewBox="0 0 300 450" xmlns="http://www.w3.org/2000/svg">
          <rect x="150" y="50" width="90" height="400" fill="#082E5C"/>
          <rect x="162" y="70" width="15" height="20" fill="#FFDA0C"/>
          <rect x="187" y="70" width="15" height="20" fill="#FFDA0C"/>
          <rect x="212" y="70" width="15" height="20" fill="#FFDA0C"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#082E5C] mb-4">
            Soluciones para Todos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Plataformas especializadas según tu rol en la comunidad
          </p>
        </div>

        {/* Profiles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {userProfiles.map((profile, index) => {
            const IconComponent = iconMap[profile.icon];
            return (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 hover:border-[#FFDA0C] bg-white overflow-hidden"
              >
                <div className="h-2 bg-gradient-to-r from-[#00D4D8] to-[#FFDA0C]"></div>
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-[#082E5C] to-[#00D4D8] rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-white" size={28} />
                  </div>
                  <CardTitle className="text-xl text-[#082E5C]">
                    {profile.type}
                  </CardTitle>
                  <CardDescription className="text-gray-600">
                    {profile.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {profile.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle className="text-[#00D4D8] flex-shrink-0 mt-0.5" size={18} />
                        <span className="text-sm text-gray-700">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <CTABanner />
      </div>
    </section>
  );
};

export default UserProfiles;
